//工单
export default [{
		//事件查询
		path: '/eventsWithOrder',
		name: 'eventsWithOrder',
		component: () => import('@/page/event/events.vue')
	},
	{
		//创建工单(普通用户)
		path: '/createOrder',
		name: 'createOrder',
		component: () => import('@/page/order/createOrder/createOrder.vue')
	}, {
		//创建工单(普通用户)手动
		path: '/newCreateOrder',
		name: 'newCreateOrder',
		component: () => import('@/page/order/createOrder/newCreateOrder.vue')
	}, {
		//创建工单(普通用户)自动
		path: '/zidongCreateOrder',
		name: 'zidongCreateOrder',
		component: () => import('@/page/order/createOrder/zidongCreateOrder.vue')
	},{
		//拷贝工单
		path: '/copyOrder',
		name: 'copyOrder',
		component: () => import('@/page/order/createOrder/copyOrder.vue')
	}, {
		path: '/realOrderList',
		name: 'realOrderList',
		component: () => import('@/page/order/search/realOrderList.vue')
	}, {
		path: '/historyOrderList',
		name: 'historyOrderList',
		component: () => import('@/page/order/search/historyOrderList.vue')
	}, {
		path: '/recycleBin',
		name: 'recycleBin',
		component: () => import('@/page/order/search/recycleBin.vue')
	}, {
		path: '/systemRelease',
		name: 'systemRelease',
		component: () => import('@/page/order/search/systemRelease.vue')
	}, {
		path: '/searchOrderList',
		name: 'searchOrderList',
		component: () => import('@/page/order/search/searchOrderList.vue')
	}, {
		//新工单查询
		path: '/newsearchOrderList',
		name: 'newsearchOrderList',
		component: () => import('@/page/order/search/newsearchOrderList.vue')
	},{
		//新工单查询1111
		path: '/newsearchOrderListCopy',
		name: 'newsearchOrderListCopy',
		component: () => import('@/page/order/search/newsearchOrderListCopy.vue')
	},{
		path: '/workFlowDefine',
		name: 'workFlowDefine',
		component: () => import('@/page/order/flow/workFlowDefine.vue')
	}, {
		path: '/newworkFlowDefine',
		name: 'newworkFlowDefine',
		component: () => import('@/page/order/flow/newworkFlowDefine.vue')
	},{
		path: '/publicWorkFlowDefine',
		name: 'publicWorkFlowDefine',
		component: () => import('@/page/order/flow/publicWorkFlowDefine.vue')
	},{
		path: '/newpublicWorkFlowDefine',
		name: 'newpublicWorkFlowDefine',
		component: () => import('@/page/order/flow/newpublicWorkFlowDefine.vue')
	}, {
		path: '/orderGroupDefine',
		name: 'orderGroupDefine',
		component: () => import('@/page/order/orderGroup/orderGroupDefine.vue')
	}, {
		path: '/dealOrder',
		name: 'dealOrder',
		component: () => import('@/page/order/dealOrder/dealOrder.vue')
	}, {
		path: '/orderControl',
		name: 'orderControl',
		component: () => import('@/page/order/search/orderControl.vue')
	}, {
		//工单(管理员)
		path: '/recycleBinForAdmin',
		name: 'recycleBinForAdmin',
		component: () => import('@/page/order/admin/recycleBinForAdmin.vue')
	}, {
		path: '/realOrderListForAdmin',
		name: 'realOrderListForAdmin',
		component: () => import('@/page/order/admin/realOrderListForAdmin.vue')
	}, {
		path: '/historyOrderListForAdmin',
		name: 'historyOrderListForAdmin',
		component: () => import('@/page/order/admin/historyOrderListForAdmin.vue')
	}, {
		path: '/systemReleaseForAdmin',
		name: 'systemReleaseForAdmin',
		component: () => import('@/page/order/admin/systemReleaseForAdmin.vue')
	}, {
		// 消缺管理
		path: '/obviateDefectsManage',
		name: 'obviateDefectsManage',
		component: () => import('@/page/order/defectManage/obviateDefectsManage.vue')
	}, {
		// 消缺管理(新)
		path: '/newobviateDefectsManage',
		name: 'newobviateDefectsManage',
		component: () => import('@/page/order/defectManage/newobviateDefectsManage.vue')
	},{
		// 部门管理
		path: '/department',
		name: 'department',
		component: () => import('@/page/order/defectManage/department.vue')
	}
]